// 导入axios
import axios from 'axios'
import {common} from './common.js'
import router from '../router/index'
import {postLoginAPI} from './api/api'
//1. 创建新的axios实例，
const baseURL = 'https://saas.203erp.com/v1'  //  http://120.76.240.144:8001/v1   https://saas.203erp.com/v1   http://test.erp203.com:8001/v1
const urlAuth = 'institution'  //institutio
const request = axios.create({
  // 公共接口
  baseURL: baseURL,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 10 * 1000
})
let isLock = false
let refreshsubscribers = [];
//push所有请求到数组中

function subscribetokenrefresh(cb) {
  console.log('----------cd:', cb)
  refreshsubscribers.push(cb)
}
//刷新请求（refreshsubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据）

function onrrefreshed(token) {
  console.log('-----------onrrefreshed-----', token)
  refreshsubscribers.map(cb => cb(token))
  console.log('------refreshsubscribers--', refreshsubscribers)
}
// 2.请求拦截器
request.interceptors.request.use(config => {
  //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等
   // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
   //或者使用localstorage，根据项目需求更换    
   const noCheckToken = [ // 不校验token的接口
    '/rbac/wx/tenant/user/login',
    '/rbac/wx/third/account/register',
    '/rbac/wx/tenant/user/third/account/create',
    '/rbac/wx/tenant/user/third/account/create/pre/check',
    '/rbac/wx/tenant/staff/check/exist'
    ]
   config.data = JSON.stringify(config.data);
   config.headers = {
     'Content-Type':'application/json;charset=UTF-8',
     'Authorization':common.getCache('token')
   }
   if(!noCheckToken.some(item => {return config.url == item}) && common.getCache('token') && common.getCache('tokenCreateTime') && (new Date().getTime() - Number(common.getCache('tokenCreateTime')) > 1800000)) {
    if(!isLock) {
      isLock = true
      const refresh = new Promise((resolve, reject) => {
        postLoginAPI({ 
          loginMode: 2,
          productId: 1,
          clientId: '1004',
          thirdUniqueId: common.getCache('openid'),
        }).then(res => {
            isLock = false
            if (res.resultCode == 200) {
                console.log('请求token续期接口-----------------：', res)
                // token生成时间，用于判断token是否快要过期，进行token续期
                common.setCache('tokenCreateTime', new Date().getTime())
                common.setCache('token',res.data.token)
                common.setCache('customerInfo',JSON.stringify(res.data))
                onrrefreshed(res.data.token)
                config.headers.Authorization = res.data.token
                refreshsubscribers = []
            }else {
              onrrefreshed()
              refreshsubscribers = []
            }
            resolve(config)
        })
      })

      return refresh;
    }else {
      console.log('---------等待续期接口')
        const retry = new Promise((resolve, reject) => {
            subscribetokenrefresh((token) => {
                console.log('-----token:', token)
                config.headers.Authorization = token

                //将请求挂起

                resolve(config)
            })
        })
        return retry
    }
   }else {
    return config
   }
   // if(token){
   //   config.params = {'token':token}
   // }
  
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
request.interceptors.response.use(response => {
  //接收到响应数据并成功后的一些共有的处理，关闭loading等
  switch(response.data.resultCode){
    case 401:
      console.log("token删除了")
      if(common.getCache('nowPath' != '/login')) {
        router.push({
          path: "/login",
        });
      }
      
      // window.localStorage.removeItem("token")
      common.removeCache("token")
  }

  return response.data

}, error => {
   /***** 接收到异常响应的处理开始 *****/
  if (error && error.response) {
    // 1.公共错误处理
    // 2.根据响应码具体处理
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break;
      case 401:
        error.message = '未授权，请重新登录'
        // alert("401")
        // window.localStorage.removeItem('token')
        common.removeCache("token")
        break;
      case 403:
        error.message = '拒绝访问'
        break;
      case 404:
        error.message = '请求错误,未找到该资源'
        // window.location.href = "/NotFound"
        break;
      case 405:
        error.message = '请求方法未允许'
        break;
      case 408:
        error.message = '请求超时'
        break;
      case 500:
        error.message = '服务器端出错'
        break;
      case 501:
        error.message = '网络未实现'
        break;
      case 502:
        error.message = '网络错误'
        break;
      case 503:
        error.message = '服务不可用'
        break;
      case 504:
        error.message = '网络超时'
        break;
      case 505:
        error.message = 'http版本不支持该请求'
        break;
      default:
        error.message = `连接错误${error.response.status}`
    }
  } else {
    // 超时处理
    if (JSON.stringify(error).includes('timeout')) {
      console.log('服务器响应超时，请刷新当前页')
    }
    error.message('连接服务器失败')
  }

  /***** 处理结束 *****/
  //如果不需要错误处理，以上的处理过程都可省略
  return Promise.resolve(error.response)
})
//4.导入文件
export {request}
export {baseURL}
export {urlAuth}

